import { AnyAction } from 'redux';
import loginTypes, {
    LoginActionTypes,
    UserState,
    setUserDataAction,
    removeUserDataAction,
    BankAccount,
    User,
    Investor,
} from './types';

function loginReq(userData: UserState, url_key?: string): LoginActionTypes {
    return {
        type: loginTypes.LOGIN_REQ,
        payload: { user_data: userData, url_key },
    };
}

function loginReqSuccess(): LoginActionTypes {
    return {
        type: loginTypes.LOGIN_REQ_SUCCESS,
    };
}

function loginReqFailed(): LoginActionTypes {
    return {
        type: loginTypes.LOGIN_REQ_FAILED,
    };
}

function setUserData(userData: UserState): setUserDataAction {
    return {
        type: loginTypes.SET_USER_DATA,
        payload: userData,
    };
}

function removeUserData(): removeUserDataAction {
    return {
        type: loginTypes.REMOVE_USER_DATA,
    };
}

function signUpReq(userData: UserState): LoginActionTypes {
    return {
        type: loginTypes.SIGN_UP_REQ,
        payload: { user_data: userData },
    };
}

function updateBankDetails(bankData: BankAccount[]): AnyAction {
    return {
        type: loginTypes.UPDATE_BANKDETAILS,
        payload: bankData,
    };
}

function updateUserProfile(user: User): AnyAction {
    return {
        type: loginTypes.UPDATE_USER_PROFILE,
        payload: user,
    };
}

function updateKYCInfo(kyc: any): AnyAction {
    return {
        type: loginTypes.UPDATE_KYC_INFO,
        payload: kyc,
    };
}

function updateInvestorInfo(investor: Investor): AnyAction {
    return {
        type: loginTypes.UPDATE_INVESTOR_PROFILE,
        payload: investor,
    };
}

function updateMyinfo(path?: 'setting' | 'onboarding'): AnyAction {
    return {
        type: loginTypes.UPDATE_MYINFO_PATH,
        payload: path,
    };
}

function fetchInvestor(uuid: string): AnyAction {
    return {
        type: loginTypes.FETCH_INVETSOR_BY_UUID,
        payload: uuid,
    };
}

const LoginActions = {
    loginReq,
    loginReqSuccess,
    loginReqFailed,
    setUserData,
    removeUserData,
    signUpReq,
    updateBankDetails,
    updateUserProfile,
    updateKYCInfo,
    updateInvestorInfo,
    updateMyinfo,
    fetchInvestor,
};

export default LoginActions;
